export const BASE_URL = process.env.REACT_APP_API_BASE_URL
export const ENTRY_POINT = BASE_URL + process.env.REACT_APP_API_ENTRYPOINT

export const roles = {
  ROLE_ADMIN: 'ROLE_SUPER_ADMIN',
  ROLE_USER: 'ROLE_USER',
  ROLE_CLIENT: 'ROLE_CLIENT'
}
